import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Storage } from '@ionic/storage';
import { Observable } from 'rxjs';
import { filter, map, switchMap, tap } from 'rxjs/operators';
import { D2CUser } from '../providers/d2c-user';

import { AuthService } from './auth.service';
import { commonConstants } from '../constants/common.constants';

@Injectable()
export class AuthGuardWithForcedLogin {
  constructor(
    private authService: AuthService,
    private d2cUserService: D2CUser
  ) {}

  canVendorEnterCentral(): boolean {
    try {
      if (this.d2cUserService.isTelusMember()) {
        return true;
      } else {
        const vendor = this.d2cUserService.vendor;
        if (!vendor) {
          return false;
        }

        const canVendorEnter = vendor.isActive;
        return canVendorEnter;
      }
    } catch (e) {
      console.error(e);
      return false;
    }
  }

  checkLogin(state: RouterStateSnapshot) {
    return this.authService.canActivateProtectedRoutes$.pipe(
      map((response) => {
        const isAuthenticated = this.authService.hasValidToken();
        const canVendorEnterCentral = this.canVendorEnterCentral();

        // Always store the URL, regardless of authentication status
        sessionStorage.setItem(
          commonConstants.LAST_URL_BEFORE_LOGIN,
          state.url
        );

        if (!isAuthenticated) {
          this.d2cUserService.processLogout();
        } else if (isAuthenticated && !canVendorEnterCentral) {
          // User authenticated but cannot enter central
        } else {
          // User authenticated and can enter central
        }

        const result = isAuthenticated || this.authService.login(state.url);
        return result;
      })
    );
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.checkLogin(state) as any;
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.canActivate(childRoute, state);
  }
}
